import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {layout} from 'icsoc-antd-ex';
import UnionComponent from 'Components/union/unionComponent';
import tQuestionStudyActions from 'Actions/ai/questionStudy';
import Search from './search';
import Tabs from './tabs';
import TableList from './tableList';

const {BaseContentMainHeader} = layout;

class QuestionStudy extends UnionComponent {
  constructor(props) {
    super(props);

    this.state = {
      tableListLoading: false,
    };
  }

  componentWillUnmount() {
    const {actions} = this.props;

    actions.setSearchData({wordStrategyId: 0});
    actions.setTabActiveKey('1');
    actions.setPageStatus({pageNum: 1, pageSize: 20});
  }

  render() {
    const {tableListLoading} = this.state;

    return (
      <React.Fragment>
        <BaseContentMainHeader title="问题学习" />

        <Search getTableList={this.getTableList} />

        <Tabs getTableList={this.getTableList} />

        <TableList
          loading={tableListLoading}
          setTableListLoading={this.setTableListLoading}
          getTableList={this.getTableList}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({aiQuestionStudy}) => ({
  tabActiveKey: aiQuestionStudy.tabActiveKey,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(tQuestionStudyActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(QuestionStudy);
